import React from 'react';
import styled from 'styled-components';
import { AboutUsProvideCard } from '../../../../services/about-us/fetchAboutUsPageContent';
import { Counter } from '../../../projectDetails/partials/Results/Counter';
import { device } from '../../../../constants';
import { Text } from '../../../../components';
import { CardTitle } from '../../../../components/CardTitle/CardTitle';

interface AboutUsProvideSwiperItemProps {
  item: AboutUsProvideCard;
  length: number;
}

const AboutUsProvideSwiperItem = ({
  item,
  length,
}: AboutUsProvideSwiperItemProps) => {
  return (
    <AboutUsProvideSwiperItemWrapper>
      <CounterText>
        <Counter index={item.id} length={length} />
      </CounterText>
      <CardTitle title={item.Title} weight={600} />
      <Text text={item.Description} />
    </AboutUsProvideSwiperItemWrapper>
  );
};
const AboutUsProvideSwiperItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 40px;
  @media screen and (${device.lg}){
    gap: 20px;
  }
  @media screen and (${device.sm}) {
    gap: 10px;
    > h4 {
      font-size: 16px;
      line-height: 1.5;
    }
  }
`;

const CounterText = styled.div`
  width: 76px;
  min-height: 70px;
  @media screen and (${device.lg}) {
    min-height: 50px;
  }
  @media screen and (${device.sm}) {
    min-height: 30px;
    width: 40px;
  }
`;

export { AboutUsProvideSwiperItem };
